import React from "react"
import Paper from "@material-ui/core/Paper";


interface IProps {
    t: any;
}

class SowContent extends React.Component <IProps, {}> {

    componentDidMount(): void {
        document.title = this.props.t('info.doctitle')
    }

    render() {
        const { t } = this.props;
        return (
            <div>
                <h3> { t('info.introduction') } </h3>
                <Paper style={{padding: "10px", margin: "25px"}}>
                <ul>
                    <li>
                        <a href="https://www.hama.com/lvs" target="_blank">{t('info.prohibitedSubstances')}</a>
                    </li>
                    <li>
                        <a href="https://echa.europa.eu/de/candidate-list-table" target="_blank">{ t('info.svhc') }</a>
                    </li>
                </ul>
                </Paper>
            </div>
        )
    }
}

export default SowContent;